import { cn } from 'utils/utils.ts';

const Title = ({ text, className }: { text: string; className?: string }) => {
  return <div className={cn('font-[LilitaOne] text-[24px] text-primary tracking-[1px]', className)}>{text}</div>;
};

export default Title;
